import "@/App.css";
import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TodayOnOmnimuscle from "@/components/TodayOnOmnimuscle";
import DailyTip from "@/components/DailyTip";
import EggSpinCard from "@/components/EggSpinCard";
import Manifesto from "@/components/Manifesto";
import Diversity from "@/components/Diversity";
import HallOfFame from "@/components/HallOfFame";
import About from "@/components/About";
import FounderCard from "@/components/FounderCard";
import FounderPicks from "@/components/FounderPicks";
import Plans from "@/components/Plans";
import Tools from "@/components/Tools";
import MuscleTracker from "@/components/MuscleTracker";
import WorkoutOfTheWeek from "@/components/WorkoutOfTheWeek";
import RecipeOfTheWeek from "@/components/RecipeOfTheWeek";
import FoodLog from "@/components/FoodLog";
import DailyVitals from "@/components/DailyVitals";
import PhoenixArcade from "@/components/PhoenixArcade";
import Messages from "@/components/Messages";
import PublicProfile from "@/components/PublicProfile";
import AiCoach from "@/components/AiCoach";
import SignInLockedSection from "@/components/SignInLockedSection";
import MyCorner from "@/components/MyCorner";
import AffiliateStrip from "@/components/AffiliateStrip";
import HolidayEggBanner from "@/components/HolidayEggBanner";
import BroadcastBanner from "@/components/BroadcastBanner";
import Shop from "@/components/Shop";
import ShopTeaser from "@/components/ShopTeaser";
import PartnerStrip from "@/components/PartnerStrip";
import Blog from "@/components/Blog";
import Contact from "@/components/Contact";
import RecentBadges from "@/components/RecentBadges";
import AwakeningsGallery from "@/components/AwakeningsGallery";
import AwakeningRevealCinematic from "@/components/AwakeningRevealCinematic";
import NestBoxDrawer from "@/components/reward/NestBoxDrawer";
import OasisFishingPage from "@/pages/OasisFishingPage";
import RoamingZonePage from "@/pages/RoamingZonePage";
import DreamForestDungeon from "@/components/dungeon/DreamForestDungeon";
import AreasPage from "@/components/AreasPage";
import ComboUltimatesPanel from "@/components/ComboUltimatesPanel";
import DfclCollectionBook from "@/components/dfcl/CollectionBook";
import Footer from "@/components/Footer";
import Profile from "@/components/Profile";
import AuthCallback from "@/components/AuthCallback";
import BillingSuccess from "@/pages/BillingSuccess";
import BullhornBanner from "@/components/BullhornBanner";
import ChatDock from "@/components/ChatDock";
import PhoenixFlareBanner from "@/components/PhoenixFlareBanner";
import DailyCalendar from "@/components/DailyCalendar";
import FestivalBoard from "@/components/FestivalBoard";
import LootTableTuner from "@/components/LootTableTuner";
import WorldMap from "@/components/WorldMap";
import { Toaster } from "sonner";
import ConfirmDialogPortal from "@/components/ui/confirm-dialog";
import BattleAudio from "@/components/BattleAudio";
import LoginPage from "@/pages/LoginPage";
import PhoenixRushPage from "@/pages/PhoenixRushPage";
import AetherAndAshPage from "@/pages/AetherAndAshPage";
import PhantomNestPage from "@/pages/PhantomNestPage";
import PacificClock from "@/components/PacificClock";
import PhoenixCursor from "@/components/PhoenixCursor";
import PushPromptBanner from "@/components/PushPromptBanner";
import PasskeyNudge from "@/components/PasskeyNudge";
import BottomDock from "@/components/BottomDock";
import CardioTracker from "@/components/CardioTracker";
import PhoenixNest from "@/components/PhoenixNest";
import AdminPartners from "@/components/AdminPartners";
import AdminSupporters from "@/components/AdminSupporters";
import SupportersStrip from "@/components/SupportersStrip";
import SupportersPage from "@/components/SupportersPage";
import OwnerInboxBanner from "@/components/OwnerInboxBanner";
import ShoppingDrawer from "@/components/ShoppingDrawer";
import EggSpinWheel from "@/components/EggSpinWheel";
import ChefProfile from "@/components/ChefProfile";
import OnboardingTour from "@/components/OnboardingTour";
import Faq from "@/components/Faq";
import AdminFaqs from "@/components/AdminFaqs";
import AdminBilling from "@/components/AdminBilling";
import AdminPromoCodes from "@/components/AdminPromoCodes";
import AdminBosses from "@/components/AdminBosses";
import AdminHeroes from "@/components/AdminHeroes";
import AdminHeroCodex from "@/components/AdminHeroCodex";
import AdminGear from "@/components/AdminGear";
import AdminIndex from "@/components/AdminIndex";
import EventSchedulerPage from "@/components/EventSchedulerPage";
import HeroCodexEditorPage from "@/components/HeroCodexEditorPage";
import AdminDFCLDecks from "@/components/AdminDFCLDecks";
import AdminDFCLBinder from "@/components/AdminDFCLBinder";
import MarketplacePage from "@/components/MarketplacePage";
import LeaderboardsPage from "@/components/LeaderboardsPage";
import FarmPage from "@/components/FarmPage";
import SynthEggsPage from "@/components/SynthEggsPage";
import GemAtlasPage from "@/components/GemAtlasPage";
import BattlegroundsPage from "@/components/BattlegroundsPage";
import WildsPage from "@/components/WildsPage";
import LibraryPage from "@/components/LibraryPage";
import BudgetPage from "@/components/BudgetPage";
import HeroCodexPage from "@/components/HeroCodexPage";
import BattlePage from "@/components/BattlePage";
import JournalCodex from "@/pages/JournalCodex";
import MistyMap from "@/pages/MistyMap";
import TownHallPage from "@/components/TownHallPage";
import GuildPage from "@/components/GuildPage";
import UnstickGuildPage from "@/pages/UnstickGuildPage";
import DragonClassStorePage from "@/pages/DragonClassStorePage";
import DFCLRulesPage from "@/pages/DFCLRulesPage";
import GuildProgressionPage from "@/components/GuildProgressionPage";
import HeroStatSheetPage from "@/components/HeroStatSheetPage";
import GuildHallLaddersPage from "@/components/GuildHallLaddersPage";
import GuildSkillsPage from "@/components/GuildSkillsPage";import AshenApexPage from "@/components/AshenApexPage";
import GuildSkillShardsPage from "@/components/GuildSkillShardsPage";
import ChronophageComingSoon from "@/components/ChronophageComingSoon";
import SkillTreePage from "@/components/SkillTreePage";
import ColiseumPage from "@/components/ColiseumPage";
import ColiseumMatchPage from "@/components/ColiseumMatchPage";
import OpeningCinematic from "@/components/OpeningCinematic";
import AuctionHousePage from "@/components/AuctionHousePage";
import AethelgardBazaar from "@/components/AethelgardBazaar";
import AlembicPage from "@/components/AlembicPage";
import NotificationsPage from "@/components/NotificationsPage";
import TombOfAwakeningPage from "@/components/TombOfAwakeningPage";
import PostTombHaze from "@/components/PostTombHaze";
import OnboardingCariLectureModal from "@/components/OnboardingCariLectureModal";
import DinerPage from "@/components/DinerPage";
import BlueMageMenuPage from "@/components/BlueMageMenuPage";
import ConstellationShop from "@/components/ConstellationShop";
import ConstellationBanner from "@/components/ConstellationBanner";
import GymPage from "@/components/GymPage";
import TrackerCalendar from "@/components/TrackerCalendar";
import HeroClassPage from "@/components/HeroClassPage";
import BlacksmithPage from "@/components/BlacksmithPage";
import EquipmentPage from "@/components/EquipmentPage";
import WardrobePage from "@/components/WardrobePage";
import KitchenPage from "@/components/KitchenPage";
import ReceiptsPage from "@/components/ReceiptsPage";
import InstallPWAButton from "@/components/InstallPWAButton";
import KitchenHubPage from "@/components/KitchenHubPage";
import KitchenPhase2Page from "@/components/KitchenPhase2Page";
import GymPhase2Page from "@/components/GymPhase2Page";
import AvatarBuilderPage from "@/components/AvatarBuilderPage";
import ParadoxDiariesPage from "@/components/ParadoxDiariesPage";
import GlimmerSanctum from "@/components/GlimmerSanctum";
import HallOfChampionsPage from "@/components/HallOfChampionsPage";
import HallOfPhoenix from "@/components/HallOfPhoenix";
import Forums from "@/components/Forums";
import ForumPost from "@/components/ForumPost";
import PhoenixPetPage from "@/components/pet/PhoenixPetPage";
import PhoenixPetWidget from "@/components/pet/PhoenixPetWidget";
import ResetPasswordPage from "@/components/ResetPasswordPage";
import CastlePage from "@/components/CastlePage";
import Arena from "@/components/Arena";
import CommunityBanner from "@/components/CommunityBanner";
import LootHub from "@/components/LootHub";
import WiltedFriendsToast from "@/components/WiltedFriendsToast";
import BottomTabBar from "@/components/BottomTabBar";

function TopClockBanner() {
  return (
    <div
      data-testid="top-clock-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-black/80 backdrop-blur-md border-b border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 flex items-center justify-center sm:justify-between gap-3">
        <span className="hidden sm:inline text-[9px] uppercase tracking-[0.3em] text-neutral-500 font-bold">
          🦅 Flying Higher · Mind · Body · Soul 🌈
        </span>
        <PacificClock size="xs" testId="banner-clock" />
      </div>
    </div>
  );
}

function HomePage() {
  return (
    <div className="App" data-testid="home-page">
      <TopClockBanner />
      <Header />
      <HolidayEggBanner />
      <BroadcastBanner />
      <main>
        <Hero />
        <Marquee />
        <TodayOnOmnimuscle />
        <DailyTip />
        <EggSpinCard />
        <Manifesto />
        <Diversity />
        <HallOfFame />
        <About />
        <FounderCard />
        <FounderPicks />
        <Plans />
        <Tools />
        <SignInLockedSection
          anchor="tracker"
          tag="Visual Workout Tracker"
          title="Map The"
          highlight="Work."
          highlightColor="#DC2626"
          description="Click any muscle on the diagram. Log exercises, watch your weekly heat-map fill, and earn Phoenix Tokens for every set."
          icon="💪"
          bg="bg-[#080808]"
        >
          <MuscleTracker />
        </SignInLockedSection>
        <SignInLockedSection
          anchor="workout-of-the-week"
          tag="Workout of the Week"
          title="Train"
          highlight="Smarter."
          highlightColor="#DC2626"
          description="A fresh AI-built weekly split — sets, reps, rest, and focus muscles dialed in for you."
          icon="🏋️"
          bg="bg-gradient-to-b from-[#0A0A0A] via-[#1a0500] to-[#0A0A0A]"
        >
          <WorkoutOfTheWeek />
        </SignInLockedSection>
        <SignInLockedSection
          anchor="recipe-of-the-week"
          tag="Recipe of the Week"
          title="Eat"
          highlight="Like A Champ."
          highlightColor="#D4AF37"
          description="Chef-grade macros built around the week's training. Add it to your log with one click."
          icon="🍳"
          bg="bg-gradient-to-b from-[#0A0A0A] via-[#120824] to-[#0A0A0A]"
        >
          <RecipeOfTheWeek variant="homepage" />
        </SignInLockedSection>
        <SignInLockedSection
          anchor="food"
          tag="Nutrition Tracker"
          title="Fuel"
          highlight="The Work."
          highlightColor="#D4AF37"
          description="Search a 100+ food library, snap a meal photo, and watch your macros + micros track in real time."
          icon="🍱"
          bg="bg-gradient-to-b from-[#0A0A0A] via-[#1a0d2b] to-[#0A0A0A]"
        >
          <FoodLog />
        </SignInLockedSection>
        <SignInLockedSection
          anchor="vitals"
          tag="Daily Vitals"
          title="Sleep · Hydrate ·"
          highlight="Fuel."
          highlightColor="#22C55E"
          description="Log sleep, water, and quick meals to earn Phoenix Tokens, unlock streak badges, and clear weekly Bingo tiles."
          icon="🌙"
          bg="bg-gradient-to-b from-[#0A0A0A] via-[#081a14] to-[#0A0A0A]"
        >
          <DailyVitals />
        </SignInLockedSection>
        <SignInLockedSection
          anchor="ai-coach"
          tag="OMNI AI Coach"
          title="Your AI"
          highlight="Coach."
          highlightColor="#A855F7"
          description="A 6-step intake builds a personalized training + nutrition plan in seconds. Pin it to your profile or print to PDF."
          icon="🤖"
          bg="bg-gradient-to-b from-[#0A0A0A] via-[#150a25] to-[#0A0A0A]"
        >
          <AiCoach />
        </SignInLockedSection>
        <ShopTeaser />
        <AffiliateStrip placement="homepage" title="Roc's Daily Stack · Partners" variant="carousel" />
        <SupportersStrip placement="homepage" />
        <Blog />
        <Contact />
      </main>
      <RecentBadges />
      <Footer />
    </div>
  );
}

function ProfilePage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <Profile />
      <Footer />
    </div>
  );
}

function PlansPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <Plans />
      <Footer />
    </div>
  );
}

function BillingSuccessPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <BillingSuccess />
    </div>
  );
}

function CinematicGate() {
  // Auto-redirect new users to /intro once auth lands, ONLY if they
  // haven't seen the Corridor of Shadows yet. Skips owner-protected
  // pages, the cinematic itself, and the auth callback so the flow
  // never traps the user.
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthed } = useAuth();
  const checkedRef = useRef(false);
  useEffect(() => {
    if (!isAuthed) { checkedRef.current = false; return; }
    if (checkedRef.current) return;
    // Don't redirect if already on intro, auth, or admin pages
    const path = location.pathname || "/";
    if (path.startsWith("/intro") || path.startsWith("/admin") || path.startsWith("/billing")) return;
    checkedRef.current = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cinematic/state`).then((r) => {
      // Redirect to /intro if the cinematic hasn't fully completed (all 3 acts).
      const stage = r.data?.stage;
      if (stage !== "fully_complete") navigate("/intro", { replace: true });
    }).catch(() => { /* silent */ });
  }, [isAuthed, location.pathname, navigate]);
  return null;
}

function AppRouter() {
  const location = useLocation();

  // ✅ Global hash-anchor scroll — makes /#food · /#vitals · /#ai-coach etc.
  // actually jump to the matching <section id> on any page (e.g. the Gym-page
  // hub links deep-linking to homepage sections). Runs after each hash change,
  // waits a tick for late-mounting sections, and no-ops when no hash is set.
  // NOTE: Must be declared BEFORE any conditional return (Rules of Hooks).
  useEffect(() => {
    const raw = location.hash || "";
    if (!raw || raw.length < 2) return;
    const id = raw.slice(1).split("&")[0].split("?")[0];
    if (!id || id.includes("session_id=")) return;
    let cancelled = false;
    const tryScroll = (attempt = 0) => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempt < 8) {
        setTimeout(() => tryScroll(attempt + 1), 150);
      }
    };
    tryScroll();
    return () => { cancelled = true; };
  }, [location.pathname, location.hash]);

  // CRITICAL: Detect Google session_id synchronously, BEFORE any other route processing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <CinematicGate />
      <OwnerInboxBanner />
      <GlobalShoppingDrawer />
      <GlobalEggSpinWheel />
      <OnboardingTour />
      <ConstellationBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/phoenix-rush" element={<PhoenixRushPage />} />
        <Route path="/aether-and-ash" element={<AetherAndAshPage />} />
        <Route path="/phantom-nest" element={<PhantomNestPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/billing/success" element={<BillingSuccessPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/dragon-class-store" element={<DragonClassStorePage />} />
        <Route path="/arcade/rules/dfcl" element={<DFCLRulesPage />} />
        <Route path="/arcade" element={<ArcadePage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/daily" element={<DailyCalendarPage />} />
        <Route path="/festival" element={<FestivalBoardPage />} />
        <Route path="/owner/loot-tuner" element={<LootTunerPage />} />
        <Route path="/map" element={<WorldMapPage />} />
        <Route path="/cardio" element={<CardioPage />} />
        <Route path="/tracker-calendar" element={<TrackerCalendarPage />} />
        <Route path="/nest" element={<NestPage />} />
        <Route path="/corner" element={<MyCornerPage />} />
        <Route path="/admin/partners" element={<AdminPartnersPage />} />
        <Route path="/admin/supporters" element={<AdminSupportersPage />} />
        <Route path="/supporters" element={<SupportersPageWrapper />} />
        <Route path="/chief-cook/:slug" element={<ChefProfile />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/admin/faqs" element={<AdminFaqs />} />
        <Route path="/admin/billing" element={<AdminBilling />} />
        <Route path="/admin/promo-codes" element={<AdminPromoCodes />} />
        <Route path="/admin" element={<AdminIndex />} />
        <Route path="/admin/event-scheduler" element={<EventSchedulerPage />} />
        <Route path="/admin/hero-codex" element={<HeroCodexEditorPage />} />
        <Route path="/admin/dfcl-decks" element={<AdminDFCLDecks />} />
        <Route path="/admin/dfcl-binder" element={<AdminDFCLBinder />} />
        <Route path="/admin/bosses" element={<AdminBosses />} />
        <Route path="/admin/heroes" element={<AdminHeroes />} />
        <Route path="/admin/hero-codex" element={<AdminHeroCodex />} />
        <Route path="/admin/gear" element={<AdminGear />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/leaderboards" element={<LeaderboardsPage />} />
        <Route path="/farm" element={<FarmPage />} />
        <Route path="/awakenings" element={<AwakeningsGallery />} />
        <Route path="/dream-forest" element={<DreamForestDungeon />} />
        <Route path="/dungeon/dream-forest" element={<DreamForestDungeon />} />
        <Route path="/areas" element={<AreasPage />} />
        <Route path="/oasis" element={<OasisFishingPage />} />
        <Route path="/roam" element={<RoamingZonePage />} />
        <Route path="/oasis/fishing" element={<OasisFishingPage />} />
        <Route path="/dfcl" element={<DfclCollectionBook />} />
        <Route path="/dfcl/collection" element={<DfclCollectionBook />} />
        <Route path="/combo-ultimates" element={<ComboUltimatesPanel />} />
        <Route path="/synthesis-eggs" element={<SynthEggsPage />} />
        <Route path="/gem-atlas" element={<GemAtlasPage />} />
        <Route path="/battlegrounds" element={<BattlegroundsPage />} />
        <Route path="/wilds" element={<WildsPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/budget" element={<BudgetPage />} />
        <Route path="/hero-codex" element={<HeroCodexPage />} />
        <Route path="/battle" element={<BattlePage />} />
        <Route path="/codex" element={<JournalCodex />} />
        <Route path="/misty-map" element={<MistyMap />} />
        <Route path="/town-hall" element={<TownHallPage />} />
        <Route path="/guild" element={<GuildPage />} />
        {/* 🚨 Direct-URL guild escape — bypasses modals/overlays (Roc support, Sep 2026). */}
        <Route path="/unstick-guild" element={<UnstickGuildPage />} />
        <Route path="/unstick" element={<UnstickGuildPage />} />
        <Route path="/hero/stats" element={<Navigate to="/aether-and-ash" replace />} />
        <Route path="/guild/hall" element={<GuildHallLaddersPage />} />
        <Route path="/guild/progression" element={<GuildProgressionPage />} />
        <Route path="/guild/skills" element={<GuildSkillsPage />} />
        <Route path="/guild/ashen-apex" element={<AshenApexPage />} />
        <Route path="/guild/skill-shards" element={<GuildSkillShardsPage />} />
        <Route path="/guild/chronophage" element={<ChronophageComingSoon />} />
        <Route path="/coliseum" element={<ColiseumPage />} />
        <Route path="/coliseum/match/:match_id" element={<ColiseumMatchPage />} />
        <Route path="/intro" element={<OpeningCinematic />} />
        <Route path="/auction-house" element={<AuctionHousePage />} />
        <Route path="/bazaar" element={<AethelgardBazaar />} />
        <Route path="/aethelgard-bazaar" element={<AethelgardBazaar />} />
        <Route path="/alembic" element={<AlembicPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/tomb" element={<TombOfAwakeningPage />} />
        <Route path="/tomb-of-awakening" element={<TombOfAwakeningPage />} />
        <Route path="/diner" element={<DinerPage />} />
        <Route path="/blue-mage-menu" element={<BlueMageMenuPage />} />
        <Route path="/constellation" element={<ConstellationShop />} />
        <Route path="/gym" element={<GymPage />} />
        <Route path="/hero-class" element={<HeroClassPage />} />
        <Route path="/skill-tree" element={<SkillTreePage />} />
        <Route path="/skill-tree/:hero_id" element={<SkillTreePage />} />
        <Route path="/blacksmith" element={<BlacksmithPage />} />
        <Route path="/equipment" element={<EquipmentPage />} />
        <Route path="/armory" element={<EquipmentPage />} />
        <Route path="/armory/preview" element={<WardrobePage />} />
        <Route path="/wardrobe" element={<WardrobePage />} />
        <Route path="/hero-preview" element={<WardrobePage />} />
        <Route path="/kitchen" element={<KitchenPage />} />
        <Route path="/receipts" element={<ReceiptsPage />} />
        <Route path="/kitchen-hub" element={<KitchenHubPage />} />
        <Route path="/interactive-kitchen" element={<KitchenPhase2Page />} />
        <Route path="/interactive-gym" element={<GymPhase2Page />} />
        <Route path="/avatar" element={<AvatarBuilderPage />} />
        <Route path="/paradox-diaries" element={<ParadoxDiariesPage />} />
        <Route path="/glimmers" element={<GlimmerSanctum />} />
        <Route path="/hall-of-champions" element={<HallOfChampionsPage />} />
        <Route path="/hall-of-phoenix" element={<HallOfPhoenix />} />
        <Route path="/forums" element={<Forums />} />
        <Route path="/forums/p/:post_id" element={<ForumPost />} />
        <Route path="/pet" element={<PhoenixPetPage />} />
        <Route path="/arena" element={<ArenaPage />} />
        <Route path="/u/:handle" element={<PublicProfile />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/castle" element={<CastlePage />} />
        {/* 🩹 P0 blank-page alias routes (Feb 2026) — direct-URL paths users
            hit via shared links / notifications / bookmarks that previously
            rendered a blank screen because no Route matched. Redirect each
            one to its sensible existing destination so nothing dead-ends. */}
        <Route path="/hero"     element={<Navigate to="/hero-codex" replace />} />
        <Route path="/campaign" element={<Navigate to="/wilds"      replace />} />
        <Route path="/vip"      element={<Navigate to="/plans"      replace />} />
        <Route path="/wheel"    element={<Navigate to="/daily"      replace />} />
        {/* 🛟 Catch-all — unknown routes fall home instead of a black screen. */}
        <Route path="*"         element={<Navigate to="/"           replace />} />
      </Routes>
    </>
  );
}

function GlobalShoppingDrawer() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("omnimuscle:open-shopping", onOpen);
    return () => window.removeEventListener("omnimuscle:open-shopping", onOpen);
  }, []);
  return <ShoppingDrawer open={open} onClose={() => setOpen(false)} />;
}

function GlobalEggSpinWheel() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("omnimuscle:open-egg-spin", onOpen);
    return () => window.removeEventListener("omnimuscle:open-egg-spin", onOpen);
  }, []);
  return <EggSpinWheel open={open} onClose={() => setOpen(false)} />;
}

function MessagesPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <Messages />
      <Footer />
    </div>
  );
}

function DailyCalendarPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <DailyCalendar />
      <Footer />
    </div>
  );
}

function FestivalBoardPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <FestivalBoard />
      <Footer />
    </div>
  );
}

function LootTunerPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <LootTableTuner />
      <Footer />
    </div>
  );
}

function WorldMapPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <WorldMap />
      <Footer />
    </div>
  );
}

function ArenaPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <Arena />
      <Footer />
    </div>
  );
}

function ArcadePage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <PhoenixArcade />
      <Footer />
    </div>
  );
}

function ShopPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <SignInLockedSection
        anchor="shop"
        tag="Phoenix Shop"
        title="The"
        highlight="Phoenix Shop."
        highlightColor="#D4AF37"
        description="Real merch, exclusive cosmetics, and Phoenix Token boosters — all redeemable with your Omni Dollars."
        icon="🛍️"
        bg="bg-gradient-to-b from-[#0A0A0A] via-[#1a0d2b] to-[#0A0A0A]"
      >
        <Shop />
      </SignInLockedSection>
      <Footer />
    </div>
  );
}

function CardioPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <CardioTracker />
      <Footer />
    </div>
  );
}

function TrackerCalendarPage() {
  return (
    <div className="App bg-black min-h-screen">
      <TopClockBanner />
      <Header />
      <SignInLockedSection
        anchor="tracker-calendar"
        tag="Full Tracker Calendar"
        title="The"
        highlight="Tracker Calendar."
        highlightColor="#10B981"
        description="One canvas for Food, Strength, and Cardio — log missed days, plan ahead, or edit any past entry."
        icon="📅"
        bg="bg-black"
      >
        <TrackerCalendar />
      </SignInLockedSection>
      <Footer />
    </div>
  );
}

function NestPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <SignInLockedSection
        anchor="nest"
        tag="Phoenix Nest"
        title="The"
        highlight="Phoenix Nest."
        highlightColor="#A855F7"
        description="Hatch rare eggs, collect colored feathers, and personalize your profile with cosmetic drops."
        icon="🥚"
        bg="bg-gradient-to-b from-[#0A0A0A] via-[#150a25] to-[#0A0A0A]"
      >
        <PhoenixNest />
      </SignInLockedSection>
      <Footer />
    </div>
  );
}

function MyCornerPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <MyCorner />
      <AffiliateStrip placement="my_corner" title="My Daily Stack" variant="carousel" />
      <SupportersStrip placement="my_corner" />
      <Footer />
    </div>
  );
}

function AdminPartnersPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <AdminPartners />
      <Footer />
    </div>
  );
}

function AdminSupportersPage() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <AdminSupporters />
      <Footer />
    </div>
  );
}

function SupportersPageWrapper() {
  return (
    <div className="App">
      <TopClockBanner />
      <Header />
      <SupportersPage />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BullhornBanner />
        <PhoenixFlareBanner />
        <CommunityBanner />
        <AppRouter />
        <PhoenixCursor />
        <PushPromptBanner />
        <PasskeyNudge />
        <BottomDock />
        <PhoenixPetWidget />
        <LootHub />
        <WiltedFriendsToast />
        <BottomTabBar />
        <OnboardingQuestWatcher />
        <ChatDock />
        <InstallPWAButton />
        <PostTombHaze />
        <Toaster theme="dark" position="top-right" />
        {/* ✨ Awakening reveal cinematic — listens on window for
            `omnimuscle:awakening-reveal` events and shows a screen-fill
            bloom + name reveal. Mount once at the app root so any component
            can `fireAwakeningReveal({hero_id})` without prop-drilling. */}
        <AwakeningRevealCinematic />
        {/* 🎁 Boss Nest Box drawer — pick-1-of-5 modal (Mar 5, 2026) */}
        <NestBoxDrawer />
        {/* ✅ Global confirm dialog — replaces window.confirm() so upgrade
            buttons work inside the preview iframe. */}
        <ConfirmDialogPortal />
        {/* 🔊 Battle audio placeholder — owner-supplied loop + victory fanfare. */}
        <BattleAudio />
      </AuthProvider>
    </BrowserRouter>
  );
}

/**
 * 📜 OnboardingQuestWatcher — polls /api/onboarding/state every 30s and
 * surfaces the Cari lecture modal when stage = "cari_lecture_pending".
 * Idempotent — modal only mounts once stage flips back to "asking_around".
 */
function OnboardingQuestWatcher() {
  const [stage, setStage] = useState(null);

  const poll = async () => {
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/onboarding/state`, {
        credentials: "include",
      });
      if (r.ok) {
        const body = await r.json();
        setStage(body.stage);
      }
    } catch (_e) { /* silent */ }
  };

  useEffect(() => {
    // Defer the initial poll to a microtask so the linter's
    // "no synchronous setState in effect" rule is satisfied.
    const initialT = setTimeout(poll, 0);
    const id = setInterval(poll, 30_000);
    // Also listen to a custom event so deposits can force-refresh
    const onPoke = poll;
    window.addEventListener("omnimuscle:onboarding-poke", onPoke);
    return () => {
      clearTimeout(initialT);
      clearInterval(id);
      window.removeEventListener("omnimuscle:onboarding-poke", onPoke);
    };
  }, []);

  if (stage !== "cari_lecture_pending") return null;
  return <OnboardingCariLectureModal onComplete={() => setStage("asking_around")} />;
}

export default App;
